
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

const OlieH = () => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/documents/2024_00418_app-Olie-H-Seed-potato.pdf';
    link.download = 'Emergency-Authorisation-Notice-Olie-H.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Card className="overflow-hidden">
      <CardContent className="p-6 md:p-8 pb-8">
        <h2 className="text-3xl font-bold mb-6 text-primary">Olie - H</h2>
        <p className="text-gray-600 mb-4">
          Working with Horticulture Crop Protection UK Ltd (HCP), SPO successfully obtained from HSE an Emergency Authorisation for Olie H (paraffin oil) on seed potato.
        </p>
        <p className="text-gray-600 mb-8">
          This Emergency Authorisation relates to the use of 'Olie H' for use on seed potato for supressing the transmission of aphid-borne non-persistent viruses in seed potato. Application is to be made by horizontal hydraulic boom sprayers fitted with 3* drift reduction technology in 200 to 400 L water /ha.
        </p>
        <Button 
          onClick={handleDownload}
          className="flex items-center gap-2 w-full md:w-auto text-sm"
        >
          <Download className="w-4 h-4" />
          Download Emergency Authorisation Notice
        </Button>
      </CardContent>
    </Card>
  );
};

export default OlieH;
